import { Box, Card, CardContent, Typography } from "@mui/material";
import AttachmentsList from "../../../Attachments/AttachmentsList";
import { useTranslation } from "react-i18next";


// Expected data: attachmentsList: {category_code, category_name, created_date, filename, id, name}[]
const AttachmentsDetailPanel = ({attachmentsList}) => {
  const { t } = useTranslation();
  attachmentsList = attachmentsList ?? [];

  const attachments = {};
  for (let attch of attachmentsList) {
    if (!attachments.hasOwnProperty(attch.category_name))
      attachments[attch.category_name] = [];
    attachments[attch.category_name].push(attch);
  }
  
  const attachmentsQty = Object.values(attachments).reduce((acumulator, currentValue) => acumulator + currentValue.length, 0);

  return (
    <Card>
      <CardContent>
        <Box>
          <Typography variant="h5">
            { t('common:text.attachments_title') } ({attachmentsQty})
          </Typography>
        </Box>
        <Box>
          { 
          Object.keys(attachments).map((category) => (
            <Box marginBottom={2} key={category}>
              <AttachmentsList title={category} 
                attachments={attachments[category]} 
                downloadURL="contract/download_attachment/:attachmentID"/>
            </Box>
          )) 
          }
        </Box>
      </CardContent>
    </Card>
  )
}


export default AttachmentsDetailPanel;